  (function() {
  var scriptConfig = document.currentScript;
  var checkoutLabel = scriptConfig && scriptConfig.dataset.checkoutLabel
    ? scriptConfig.dataset.checkoutLabel
    : 'Checkout';

  function initQuickCartDiscount() {
    if (window.__NEQuickCartDiscountSmoothLineItemsV15) return;
    window.__NEQuickCartDiscountSmoothLineItemsV15 = true;

    var root = '/';
    var userClearedDiscount = false;

    var lineItemCouponOverrides = {
      RACING: 20
    };

    var pendingCartFetch = null;
    var lastCartJson = null;
    var lastCartSyncAt = 0;
    var syncTimer = null;

    var discountActionToken = 0;
    var lastDiscountEventSignature = '';
    var lastFrontendBroadcastCode = null;
    var productDiscountPercentageCache = {};
    var quickCartEnteredCodes = {};
    var verifiedManualCodes = {};
    var verifiedConfiguredCodes = {};
    var checkoutDiscountSyncStarted = false;

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      root = Shopify.routes.root;
    }

    function buildUrl(path) {
      return root + path.replace(/^\/+/, '');
    }

    function wait(ms) {
      return new Promise(function(resolve) {
        setTimeout(resolve, ms);
      });
    }

    function nextDiscountActionToken() {
      discountActionToken += 1;
      return discountActionToken;
    }

    function isCurrentDiscountAction(token) {
      return token === discountActionToken;
    }

    function stopOutdatedDiscountAction() {
      return Promise.reject({
        __neOutdatedDiscountAction: true
      });
    }
  function getDiscountBadgeHtml(percentage) {
  return '';
  }

    function formatMoney(cents) {
      return window.NE.Utils.formatMoney(cents);
    }

    function fetchCart() {
      if (pendingCartFetch) return pendingCartFetch;

      pendingCartFetch = fetch(buildUrl('/cart.js') + '?t=' + Date.now(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(cart) {
          lastCartJson = cart;
          return cart;
        })
        .finally(function() {
          pendingCartFetch = null;
        });

      return pendingCartFetch;
    }

    function forceFreshCart() {
      pendingCartFetch = null;
      lastCartSyncAt = 0;

      return fetch(buildUrl('/cart.js') + '?t=' + Date.now(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(cart) {
          lastCartJson = cart;
          return cart;
        });
    }

    function updateCartDiscount(code) {
      var discountCodes = code || '';

      if (
        window.NE &&
        window.NE.UtmDiscount &&
        typeof window.NE.UtmDiscount.mergeCodes === 'function'
      ) {
        discountCodes = window.NE.UtmDiscount.mergeCodes(discountCodes);
      }

      return fetch(buildUrl('/cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: discountCodes
        })
      }).then(function(res) {
        return res.json();
      });
    }

    function addUniqueDiscountCode(codes, code) {
      var normalizedCode = String(code || '').trim().toUpperCase();

      if (normalizedCode && codes.indexOf(normalizedCode) === -1) {
        codes.push(normalizedCode);
      }
    }

    function addDiscountApplicationCode(codes, application) {
      if (!application) return;

      var applicationType = String(application.type || '').toLowerCase();

      if (applicationType && applicationType !== 'discount_code') return;

      addUniqueDiscountCode(codes, application.code || application.title);
    }

    function getApplicableCartDiscountCodes(cart) {
      var codes = [];

      if (!cart) return codes;

      if (Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach(function(discount) {
          if (discount && discount.applicable === true) {
            addUniqueDiscountCode(codes, discount.code);
          }
        });
      }

      /*
        Some Shopify cart responses expose an active code only through its
        applied discount object. Include those codes so an ineligible new
        code can never displace an already applied one during restoration.
      */
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach(function(application) {
          addDiscountApplicationCode(codes, application);
        });
      }

      if (Array.isArray(cart.items)) {
        cart.items.forEach(function(item) {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach(function(allocation) {
            addDiscountApplicationCode(
              codes,
              allocation && allocation.discount_application
            );
          });
        });
      }

      return codes;
    }

    function mergeDiscountCodes(codes, code) {
      var merged = Array.isArray(codes) ? codes.slice() : [];
      var normalizedCode = String(code || '').trim().toUpperCase();

      if (!normalizedCode) return merged;

      if (getConfiguredFrontendDiscountCodes().indexOf(normalizedCode) !== -1) {
        merged = merged.filter(function(existingCode) {
          return existingCode !== normalizedCode;
        });
        merged.unshift(normalizedCode);
      } else if (merged.indexOf(normalizedCode) === -1) {
        merged.push(normalizedCode);
      }

      return merged;
    }

    function cartHasApplicableDiscountCode(cart, code) {
      var normalizedCode = String(code || '').trim().toUpperCase();

      return getApplicableCartDiscountCodes(cart).indexOf(normalizedCode) !== -1;
    }

    function cartHasAllApplicableDiscountCodes(cart, codes) {
      var applicableCodes = getApplicableCartDiscountCodes(cart);

      return codes.every(function(code) {
        return applicableCodes.indexOf(code) !== -1;
      });
    }

    function getVisibleCartDiscountCodes(cart) {
      return getApplicableCartDiscountCodes(cart).filter(function(code) {
        return !isUtmDiscountCode(code);
      });
    }

    function getQuickCartDiscountCodeLabel(cart, fallbackCode) {
      var visibleCodes = getVisibleCartDiscountCodes(cart);

      if (visibleCodes.length) {
        return visibleCodes.join(' + ');
      }

      return String(fallbackCode || '').trim().toUpperCase();
    }

    function getPreferredQuickCartDiscountCode(cart, fallbackCode) {
      var visibleCodes = getVisibleCartDiscountCodes(cart);
      var normalizedFallback = String(fallbackCode || '').trim().toUpperCase();
      var storedCode = getStoredFrontendDiscountCode();

      if (storedCode) {
        storedCode = String(storedCode).trim().toUpperCase();

        if (visibleCodes.indexOf(storedCode) !== -1) {
          return storedCode;
        }
      }

      if (normalizedFallback && visibleCodes.indexOf(normalizedFallback) !== -1) {
        return normalizedFallback;
      }

      return visibleCodes.length ? visibleCodes[0] : normalizedFallback || null;
    }

    function getConfiguredApplicableFrontendDiscountCode(cart) {
      var applicableCodes = getApplicableCartDiscountCodes(cart);
      var configuredCodes = getConfiguredFrontendDiscountCodes();

      for (var i = 0; i < configuredCodes.length; i++) {
        if (applicableCodes.indexOf(configuredCodes[i]) !== -1) {
          return configuredCodes[i];
        }
      }

      return null;
    }

    function getConfiguredFrontendDiscountCodes() {
      var configuredCodes = [];
      var configuredElements = document.querySelectorAll(
        '[data-ne-coupon-code], [data-default-coupon-code]'
      );

      configuredElements.forEach(function(element) {
        var configuredCode = String(
          element.getAttribute('data-ne-coupon-code') ||
          element.getAttribute('data-default-coupon-code') ||
          ''
        ).trim().toUpperCase();

        addUniqueDiscountCode(configuredCodes, configuredCode);
      });

      return configuredCodes;
    }

    function rememberQuickCartEnteredCode(code) {
      code = String(code || '').trim().toUpperCase();

      if (code) {
        quickCartEnteredCodes[code] = true;
      }
    }

    function clearQuickCartCodeFromFrontendTracker(code) {
      code = String(code || '').trim().toUpperCase();

      if (!code || !quickCartEnteredCodes[code]) return;
      if (getConfiguredFrontendDiscountCodes().indexOf(code) !== -1) return;

      var storedCode = getStoredFrontendDiscountCode();

      if (!storedCode || String(storedCode).trim().toUpperCase() !== code) return;

      try {
        sessionStorage.removeItem('ne_discount_code');
        sessionStorage.removeItem('ne_discount_details');
      } catch (e) {}

      document.cookie = 'ne_discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.clear === 'function'
      ) {
        try {
          window.NE.DiscountTracker.clear();
        } catch (e) {}
      } else {
        window.dispatchEvent(new CustomEvent('ne:discount-code-cleared'));
      }

      lastFrontendBroadcastCode = null;
    }

    function preserveConfiguredFrontendDiscountCode(cart) {
      var configuredCode = getConfiguredApplicableFrontendDiscountCode(cart);

      if (!configuredCode) return;

      verifiedConfiguredCodes[configuredCode] = true;

      var storedCode = getStoredFrontendDiscountCode();

      if (
        storedCode &&
        String(storedCode).trim().toUpperCase() === configuredCode
      ) {
        return;
      }

      saveFrontendCodeOnly(configuredCode, cart, true);
    }

    function restoreApplicableDiscountCodes(codes, cart) {
      if (!codes.length) return Promise.resolve(cart);

      return updateCartDiscount(codes.join(','))
        .then(function() {
          return forceFreshCart();
        })
        .catch(function() {
          return cart;
        });
    }

    function touchDiscountRoute(code) {
      if (!code) return Promise.resolve();

      return fetch(
        buildUrl('/discount/' + encodeURIComponent(code)) +
        '?redirect=' +
        encodeURIComponent(buildUrl('/cart.js')),
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json, text/plain, */*'
          },
          cache: 'no-store'
        }
      ).catch(function() {});
    }

    function touchClearDiscountRoute() {
      return fetch(
        buildUrl('/discount/') +
        '?redirect=' +
        encodeURIComponent(buildUrl('/cart.js')),
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json, text/plain, */*'
          },
          cache: 'no-store'
        }
      ).catch(function() {});
    }

    function getDiscountBox(el) {
      return el ? el.closest('[data-qc-discount]') : null;
    }

    function getDiscountBoxes() {
      return document.querySelectorAll('[data-qc-discount]');
    }

    function showMessage(box, text, type) {
      if (!box) return;

      var msg = box.querySelector('[data-qc-discount-message]');
      if (!msg) return;

      msg.textContent = text;
      msg.className = 'qc-discount__message ' + (type || 'error');
      msg.style.display = 'block';
    }

    function hideMessage(box) {
      if (!box) return;

      var msg = box.querySelector('[data-qc-discount-message]');
      if (!msg) return;

      msg.textContent = '';
      msg.style.display = 'none';
    }

    function setLoading(box, loading) {
      if (!box) return;

      var input = box.querySelector('[data-qc-discount-input]');
      var applyBtn = box.querySelector('[data-qc-discount-apply]');
      var removeBtn = box.querySelector('[data-qc-discount-remove]');

      box.classList.toggle('is-loading', !!loading);

      if (input) input.disabled = !!loading;

      if (applyBtn) {
        applyBtn.disabled = !!loading;
        applyBtn.textContent = loading ? 'Lädt...' : 'Anwenden';
      }

      if (removeBtn) {
        removeBtn.disabled = !!loading;
      }
    }

    function openDiscountBox(box) {
      if (!box) return;

      var content = box.querySelector('[data-qc-discount-content]');
      box.classList.add('is-open');

      if (content) {
        content.style.display = 'block';
      }
    }

    function getStoredFrontendDiscountCode() {
      if (userClearedDiscount) return null;

      var code = null;

      var vanityMatch = window.location.pathname.match(/\/(coupon|youtube|crm)\/([^/?#]+)\/?$/i);

      if (vanityMatch && vanityMatch[2]) {
        return decodeURIComponent(vanityMatch[2]).toUpperCase();
      }

      var urlParams = new URLSearchParams(window.location.search);
      var discountParam = urlParams.get('ne_coupon');
      var vanityHandoffCode = null;

      try {
        vanityHandoffCode = sessionStorage.getItem('ne_vanity_discount');
      } catch (e) {}

      if (
        discountParam &&
        vanityHandoffCode &&
        discountParam.toUpperCase() === vanityHandoffCode.toUpperCase()
      ) {
        return discountParam.toUpperCase();
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.getDetails === 'function'
      ) {
        try {
          var details = window.NE.DiscountTracker.getDetails();

          if (details && details.code) {
            return details.code.toUpperCase();
          }
        } catch (e) {}
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.get === 'function'
      ) {
        try {
          code = window.NE.DiscountTracker.get();

          if (code) {
            return code.toUpperCase();
          }
        } catch (e) {}
      }

      try {
        code = sessionStorage.getItem('ne_discount_code');

        if (code) {
          return code.toUpperCase();
        }
      } catch (e) {}

      var cookieMatch = document.cookie.match(/(?:^|;\s*)ne_discount_code=([^;]+)/);

      if (cookieMatch && cookieMatch[1]) {
        return decodeURIComponent(cookieMatch[1]).toUpperCase();
      }

      return null;
    }

    function isUtmDiscountCode(code) {
      return Boolean(
        code &&
        window.NE &&
        window.NE.UtmDiscount &&
        typeof window.NE.UtmDiscount.isCode === 'function' &&
        window.NE.UtmDiscount.isCode(code)
      );
    }

    function getActiveDiscount(cart) {
      if (!cart || userClearedDiscount) return null;

      if (Array.isArray(cart.discount_codes)) {
        for (var i = 0; i < cart.discount_codes.length; i++) {
          var dc = cart.discount_codes[i];

          if (dc && dc.applicable && dc.code && !isUtmDiscountCode(dc.code)) {
            return {
              code: dc.code,
              amount: cart.total_discount || 0
            };
          }
        }
      }

      if (Array.isArray(cart.cart_level_discount_applications)) {
        for (var k = 0; k < cart.cart_level_discount_applications.length; k++) {
          var cartDiscount = cart.cart_level_discount_applications[k];

          if (cartDiscount && cartDiscount.title && !isUtmDiscountCode(cartDiscount.title)) {
            return {
              code: cartDiscount.title,
              amount: cartDiscount.total_allocated_amount || cart.total_discount || 0
            };
          }
        }
      }

      if (Array.isArray(cart.items)) {
        for (var j = 0; j < cart.items.length; j++) {
          var item = cart.items[j];

          if (
            Array.isArray(item.line_level_discount_allocations) &&
            item.line_level_discount_allocations.length
          ) {
            for (var l = 0; l < item.line_level_discount_allocations.length; l++) {
              var allocation = item.line_level_discount_allocations[l];
              var title = '';

              if (
                allocation.discount_application &&
                allocation.discount_application.title
              ) {
                title = allocation.discount_application.title;
              } else if (allocation.title) {
                title = allocation.title;
              }

              if (title && !isUtmDiscountCode(title)) {
                return {
                  code: title,
                  amount: allocation.amount || cart.total_discount || 0
                };
              }
            }
          }
        }
      }

      return null;
    }

    function saveFrontendCodeOnly(code, cart, silent) {
      if (!code) return;

      userClearedDiscount = false;
      code = String(code).toUpperCase();

      try {
        sessionStorage.setItem('ne_discount_code', code);
      } catch (e) {}

      document.cookie =
        'ne_discount_code=' +
        encodeURIComponent(code) +
        ';path=/;max-age=' +
        60 * 60 * 24 * 30;

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.save === 'function'
      ) {
        try {
          window.NE.DiscountTracker.save(code);
        } catch (e) {}
      }

      try {
        sessionStorage.setItem(
          'ne_discount_details',
          JSON.stringify({
            code: code,
            percentage: null,
            displayText: 'Code ' + code + ' applied',
            timestamp: Date.now()
          })
        );
      } catch (e) {}

      if (silent) return;

      if (lastFrontendBroadcastCode === code) return;
      lastFrontendBroadcastCode = code;

      window.dispatchEvent(new CustomEvent('ne:discount-code-updated', {
        detail: {
          code: code,
          cart: cart || null
        }
      }));

      document.dispatchEvent(new CustomEvent('discount:updated', {
        detail: {
          code: code,
          cart: cart || null
        }
      }));
    }

    function saveDiscountForFrontend(discount, cart, silent) {
      if (!discount || !discount.code) return;
      saveFrontendCodeOnly(discount.code, cart, silent);
    }

    function clearDiscountForFrontend(cart, forceClear, silent) {
      if (forceClear) {
        userClearedDiscount = true;
      }

      var storedCode = getStoredFrontendDiscountCode();

      if (storedCode && !forceClear) {
        saveFrontendCodeOnly(storedCode, cart, true);
        return;
      }

      try {
        sessionStorage.removeItem('ne_discount_code');
        sessionStorage.removeItem('ne_discount_details');
      } catch (e) {}

      document.cookie = 'ne_discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.clear === 'function'
      ) {
        try {
          window.NE.DiscountTracker.clear();
        } catch (e) {}
      } else {
        window.dispatchEvent(new CustomEvent('ne:discount-code-cleared'));
      }

      if (!silent) {
        document.dispatchEvent(new CustomEvent('discount:updated', {
          detail: {
            cart: cart
          }
        }));
      }
    }

    function findCurrentCartItemByKey(key) {
      if (!key) return null;

      if (window.CSS && typeof CSS.escape === 'function') {
        return document.querySelector('.quick-cart__item[data-key="' + CSS.escape(key) + '"]');
      }

      var items = document.querySelectorAll('.quick-cart__item[data-key]');

      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-key') === key) {
          return items[i];
        }
      }

      return null;
    }

    function isFreeGiftLineItem(item) {
      return !!(
        item &&
        item.properties &&
        String(item.properties._is_free_gift) === 'true'
      );
    }

    function getLineDiscountAmount(item) {
      var amount = 0;

      if (
        item &&
        Array.isArray(item.line_level_discount_allocations) &&
        item.line_level_discount_allocations.length
      ) {
        item.line_level_discount_allocations.forEach(function(allocation) {
          amount += Number(allocation.amount || 0);
        });
      }

      return amount;
    }

    function getCurrentLineItemCode(cart, explicitCode) {
      if (userClearedDiscount) return null;

      var preferredCode = getPreferredQuickCartDiscountCode(cart, explicitCode);

      if (preferredCode) {
        return preferredCode;
      }

      var active = getActiveDiscount(cart);

      if (active && active.code) {
        return active.code.toUpperCase();
      }

      var storedCode = getStoredFrontendDiscountCode();

      if (storedCode) {
        return storedCode.toUpperCase();
      }

      return null;
    }

    function clearDiscountTrackerProductCache() {
      productDiscountPercentageCache = {};

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.clearProductDiscountCache === 'function'
      ) {
        try {
          window.NE.DiscountTracker.clearProductDiscountCache();
        } catch (e) {}
      }

      try {
        if (window.NE && window.NE.discountProductMemoryCache) {
          window.NE.discountProductMemoryCache = {};
        }

        Object.keys(sessionStorage).forEach(function(key) {
          if (key.indexOf('ne_discount_product_cache_') === 0) {
            sessionStorage.removeItem(key);
          }
        });
      } catch (e) {}
    }

    function getProductDiscountPercentage(code, productId, item) {
      if (!code || !productId) {
        return Promise.resolve(0);
      }

      code = String(code).trim().toUpperCase();
      productId = String(productId).trim();

      if (lineItemCouponOverrides[code]) {
        return Promise.resolve(Number(lineItemCouponOverrides[code]));
      }

      var cacheKey = code + ':' + productId;

      if (Object.prototype.hasOwnProperty.call(productDiscountPercentageCache, cacheKey)) {
        return Promise.resolve(productDiscountPercentageCache[cacheKey]);
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.fetchProductDiscount === 'function'
      ) {
        return window.NE.DiscountTracker.fetchProductDiscount(code, productId)
          .then(function(percentage) {
            percentage = Number(percentage || 0);
            productDiscountPercentageCache[cacheKey] = percentage > 0 ? percentage : 0;
            return productDiscountPercentageCache[cacheKey];
          })
          .catch(function() {
            productDiscountPercentageCache[cacheKey] = 0;
            return 0;
          });
      }

      productDiscountPercentageCache[cacheKey] = 0;
      return Promise.resolve(0);
    }

    function derivePercentageFromCartAllocation(item) {
      if (!item) return 0;

      var discountAmount = getLineDiscountAmount(item);
      var originalLinePrice = Number(item.original_line_price || item.line_price || 0);

      if (discountAmount > 0 && originalLinePrice > 0) {
        return Math.round((discountAmount / originalLinePrice) * 100);
      }

      return 0;
    }

    function removeLineDiscountLists(itemEl) {
      if (!itemEl) return;

      itemEl.querySelectorAll('.quick-cart__item-discounts').forEach(function(list) {
        list.remove();
      });
    }

    function renderLineItemNormal(item) {
      if (!item || !item.key) return;

      var itemEl = findCurrentCartItemByKey(item.key);
      if (!itemEl) return;

      var priceWrapper = itemEl.querySelector('.quick-cart__item-price-wrapper');
      if (!priceWrapper) return;

      var priceFlex = priceWrapper.querySelector('.quick-cart__price-badge-flex');

      if (!priceFlex) {
        priceFlex = document.createElement('div');
        priceFlex.className = 'quick-cart__price-badge-flex';
        priceWrapper.innerHTML = '';
        priceWrapper.appendChild(priceFlex);
      }

      var originalUnitPrice = Number(item.original_price || item.price || item.final_price || 0);

      priceFlex.innerHTML =
        '<span class="quick-cart__item-price">' +
        formatMoney(originalUnitPrice) +
        '</span>';

      priceFlex.setAttribute('data-ne-line-code', '');
      priceFlex.setAttribute('data-ne-line-percentage', '0');

      removeLineDiscountLists(itemEl);
    }

    function renderLineItemDiscounted(item, code, percentage) {
      if (!item || !item.key) return;

      var itemEl = findCurrentCartItemByKey(item.key);
      if (!itemEl) return;

      var priceWrapper = itemEl.querySelector('.quick-cart__item-price-wrapper');
      if (!priceWrapper) return;

      var priceFlex = priceWrapper.querySelector('.quick-cart__price-badge-flex');

      if (!priceFlex) {
        priceFlex = document.createElement('div');
        priceFlex.className = 'quick-cart__price-badge-flex';
        priceWrapper.innerHTML = '';
        priceWrapper.appendChild(priceFlex);
      }

      var originalUnitPrice = Number(item.original_price || item.price || 0);

      if (!originalUnitPrice || !percentage || percentage <= 0) {
        renderLineItemNormal(item);
        return;
      }

      var finalUnitPrice = Math.round(originalUnitPrice - (originalUnitPrice * percentage / 100));

      if (finalUnitPrice >= originalUnitPrice) {
        renderLineItemNormal(item);
        return;
      }

      priceFlex.innerHTML =
        '<span class="quick-cart__item-price sale-price">' +
        formatMoney(finalUnitPrice) +
        '</span>' +
        '<s class="quick-cart__item-price">' +
        formatMoney(originalUnitPrice) +
        '</s>' +
        getDiscountBadgeHtml(percentage);

      priceFlex.setAttribute('data-ne-line-code', code || '');
      priceFlex.setAttribute('data-ne-line-percentage', String(percentage));

      removeLineDiscountLists(itemEl);
    }

    function isPdpDiscountedLineItem(item) {
      if (!item) return false;

      if (
        item.selling_plan_allocation ||
        item.selling_plan_id ||
        item.selling_plan_name
      ) {
        return true;
      }

      if (item.properties) {
        if (
          item.properties._ne_pdp_discount_price ||
          item.properties._pdp_discount_price ||
          item.properties._subscription_discount_price ||
          item.properties._ne_skip_coupon_discount
        ) {
          return true;
        }
      }

      var originalPrice = Number(item.original_price || 0);
      var currentPrice = Number(item.price || item.final_price || 0);

      if (
        originalPrice > 0 &&
        currentPrice > 0 &&
        currentPrice < originalPrice
      ) {
        return true;
      }

      return false;
    }

    function renderLineItemFromCartJson(item, cart, explicitCode, forceNormal) {
      if (!item || !item.key) return Promise.resolve();

      if (isFreeGiftLineItem(item)) {
        return Promise.resolve();
      }

      if (isPdpDiscountedLineItem(item)) {
        renderLineItemNormal(item);
        return Promise.resolve();
      }

      if (forceNormal || userClearedDiscount) {
        renderLineItemNormal(item);
        return Promise.resolve();
      }

      var code = getCurrentLineItemCode(cart, explicitCode);

      if (!code) {
        renderLineItemNormal(item);
        return Promise.resolve();
      }

      var productId = item.product_id;

      return getProductDiscountPercentage(code, productId, item)
        .then(function(productPercentage) {
          productPercentage = Number(productPercentage || 0);

          if (!productPercentage || productPercentage <= 0) {
            productPercentage = derivePercentageFromCartAllocation(item);
          }

          if (!productPercentage || productPercentage <= 0) {
            renderLineItemNormal(item);
            return;
          }

          renderLineItemDiscounted(item, code, productPercentage);
        })
        .catch(function() {
          var fallbackPercentage = derivePercentageFromCartAllocation(item);

          if (fallbackPercentage > 0) {
            renderLineItemDiscounted(item, code, fallbackPercentage);
          } else {
            renderLineItemNormal(item);
          }
        });
    }

    function applyLineItemCartJsonFallback(cart, explicitCode, forceNormal) {
      if (!cart || !Array.isArray(cart.items)) return Promise.resolve();

      var tasks = cart.items.map(function(item) {
        return renderLineItemFromCartJson(item, cart, explicitCode, forceNormal);
      });

      return Promise.all(tasks).then(function() {});
    }

    function refreshLineItemsFromRenderedCart(cartForFallback, explicitCode, forceNormal) {
      if (!cartForFallback) return Promise.resolve();

      return applyLineItemCartJsonFallback(cartForFallback, explicitCode, forceNormal);
    }

    function forceLineItemsForCode(code, cartOverride) {
      code = String(code || '').trim().toUpperCase();

      if (!code) {
        return Promise.resolve();
      }

      userClearedDiscount = false;

      var cartToUse = cartOverride || lastCartJson;

      if (cartToUse && Array.isArray(cartToUse.items)) {
        lastCartJson = cartToUse;
        return refreshLineItemsFromRenderedCart(cartToUse, code, false);
      }

      return forceFreshCart().then(function(cart) {
        userClearedDiscount = false;
        return refreshLineItemsFromRenderedCart(cart, code, false);
      });
    }

    function forceLineItemsForCodeWithLightRetry(code, cartOverride, actionToken) {
      code = String(code || '').trim().toUpperCase();

      if (!code) return Promise.resolve();

      userClearedDiscount = false;

      var cartToUse = cartOverride || lastCartJson;

      if (cartToUse && Array.isArray(cartToUse.items)) {
        lastCartJson = cartToUse;

        return forceLineItemsForCode(code, cartToUse).then(function() {
          if (actionToken && !isCurrentDiscountAction(actionToken)) return;

          setTimeout(function() {
            if (actionToken && !isCurrentDiscountAction(actionToken)) return;

            if (lastCartJson && Array.isArray(lastCartJson.items)) {
              forceLineItemsForCode(code, lastCartJson);
            }
          }, 250);
        });
      }

      return forceFreshCart().then(function(cart) {
        if (actionToken && !isCurrentDiscountAction(actionToken)) return;
        return forceLineItemsForCode(code, cart);
      });
    }

    function forceLineItemsNormal() {
      if (!lastCartJson || !Array.isArray(lastCartJson.items)) {
        return Promise.resolve();
      }

      return refreshLineItemsFromRenderedCart(lastCartJson, null, true);
    }

    function syncTotals(cart) {
  if (!cart) return;

  if (typeof window.NEUpdateQuickCartCheckoutTotal === 'function') {
    window.NEUpdateQuickCartCheckoutTotal(cart);
    return;
  }

  var displayTotal = getCartTotalWithoutFreeGifts(cart);
  var totalText = formatMoney(displayTotal);
  var discountText = formatMoney(cart.total_discount || 0);

  document.querySelectorAll('.quick-cart__footer-subtotal-wrap').forEach(function(el) {
    if (el.textContent !== totalText) {
      el.textContent = totalText;
    }
  });

  var discountAmount = document.querySelector('#discount-amount');
  var discountSummary = document.querySelector('#discount-summary');

  if (discountAmount && discountAmount.textContent !== discountText) {
    discountAmount.textContent = discountText;
  }

  if (discountSummary) {
    var shouldHide = Number(cart.total_discount || 0) <= 0;
    discountSummary.classList.toggle('hidden', shouldHide);
    discountSummary.style.display = shouldHide ? 'none' : '';
  }

  document.querySelectorAll('.quick-cart__submit').forEach(function(button) {
    var totalEl = button.querySelector('[data-ne-checkout-total]');

    if (totalEl) {
      if (totalEl.textContent !== totalText) {
        totalEl.textContent = totalText;
      }
      return;
    }

    var nextText = checkoutLabel + ' - ' + totalText;

    if (button.textContent.trim() !== nextText) {
      button.textContent = nextText;
    }
  });
  }

    function getCartTotalWithoutFreeGifts(cart) {
      var total = Number((cart && cart.total_price) || 0);

      if (!cart || !Array.isArray(cart.items)) {
        return total;
      }

      var giftTotal = cart.items.reduce(function(sum, item) {
        if (!isFreeGiftLineItem(item)) return sum;

        return sum + Number(item.final_line_price || item.line_price || 0);
      }, 0);

      return Math.max(0, total - giftTotal);
    }

    function replaceMoneyInMessage(template, money) {
      if (!template) return '';

      return template
        .replace(/\{\{\s*amount\s*\}\}/g, money)
        .replace(/\{\{\s*price\s*\}\}/g, money)
        .replace(/\{\{\s*remaining_amount\s*\}\}/g, money)
        .replace(/\{\{\s*remaining\s*\}\}/g, money);
    }

    function syncFreeShippingBar(cart) {
      if (!cart) return;

      var bar = document.querySelector('[data-free-shipping-bar]');
      var message = document.querySelector('.free-shipping-bar__message');

      if (!bar) return;

      var threshold = Number(bar.getAttribute('data-threshold') || 0) * 100;
      var total = Number(cart.total_price || 0);
      var remaining = Math.max(0, threshold - total);
      var progress = threshold > 0 ? Math.min(100, Math.max(0, total / threshold * 100)) : 100;

      bar.setAttribute('data-cart-total', total);

      var progressEl = bar.querySelector('.free-shipping-bar__js');

      if (progressEl) {
        progressEl.style.width = progress + '%';
      }

      if (message) {
        if (remaining <= 0) {
          message.innerHTML =
            bar.getAttribute('data-free-shipping-success-message') ||
            'Kostenloser Versand erreicht!';
        } else {
          var pending =
            bar.getAttribute('data-free-shipping-pending-message') ||
            'Nur ' + formatMoney(remaining) + ' vom kostenlosen Versand entfernt!';

          message.innerHTML = replaceMoneyInMessage(pending, formatMoney(remaining));

          if (message.innerHTML === pending) {
            message.innerHTML = 'Nur ' + formatMoney(remaining) + ' vom kostenlosen Versand entfernt!';
          }
        }
      }
    }

    function syncDefaultCouponBlock(cart) {
      window.NE = window.NE || {};
      preserveConfiguredFrontendDiscountCode(cart);
    }

    function syncDiscountBox(box, cart) {
      if (!box || !cart) return;

      var discount = getActiveDiscount(cart);
      var storedCode = getStoredFrontendDiscountCode();
      var codeToShow = getQuickCartDiscountCodeLabel(
        cart,
        discount && discount.code ? discount.code : storedCode
      );

      var label = box.querySelector('[data-qc-discount-label]');
      var activeMini = box.querySelector('[data-qc-active-mini]');
      var activeMiniCode = box.querySelector('[data-qc-active-mini-code]');
      var activeBox = box.querySelector('[data-qc-discount-active]');
      var activeCode = box.querySelector('[data-qc-active-code]');
      var activeSavings = box.querySelector('[data-qc-active-savings]');
      var input = box.querySelector('[data-qc-discount-input]');

      if (!codeToShow) {
  if (label) {
    label.textContent = box.classList.contains('is-open')
      ? 'Rabattcode eingeben'
      : 'Hast du einen Rabattcode?';
  }

  if (activeMini) {
    activeMini.style.display = 'none';
  }

  if (activeMiniCode) activeMiniCode.textContent = '';
  if (activeBox) activeBox.style.display = 'none';
  if (activeCode) activeCode.textContent = '';
  if (activeSavings) activeSavings.textContent = '';
  if (input) input.value = '';

  return;
  }

  if (label) {
  label.textContent = box.classList.contains('is-open')
    ? 'Rabattcode ändern'
    : 'Rabattcode aktiv';
  }

      if (activeMini) {
        if (activeMiniCode) {
          activeMiniCode.textContent = codeToShow;
        } else {
          activeMini.textContent = codeToShow;
        }

        activeMini.style.display = 'inline-flex';
      }

      if (activeBox) activeBox.style.display = 'flex';
      if (activeCode) activeCode.textContent = codeToShow;

      if (activeSavings) {
        if (discount && discount.amount > 0) {
          activeSavings.textContent = '(-' + formatMoney(discount.amount) + ')';
        } else {
          activeSavings.textContent = '';
        }
      }

      if (input) input.value = '';
    }

    function syncDiscountBoxes(cart) {
      getDiscountBoxes().forEach(function(box) {
        syncDiscountBox(box, cart);
      });
    }

    function setDiscountBoxesOptimistic(code) {
      getDiscountBoxes().forEach(function(box) {
        var label = box.querySelector('[data-qc-discount-label]');
        var activeMini = box.querySelector('[data-qc-active-mini]');
        var activeMiniCode = box.querySelector('[data-qc-active-mini-code]');
        var activeBox = box.querySelector('[data-qc-discount-active]');
        var activeCode = box.querySelector('[data-qc-active-code]');
        var activeSavings = box.querySelector('[data-qc-active-savings]');
        var input = box.querySelector('[data-qc-discount-input]');

        if (code) {
  if (label) {
    label.textContent = box.classList.contains('is-open')
      ? 'Rabattcode ändern'
      : 'Rabattcode aktiv';
  }

          if (activeMini) {
            if (activeMiniCode) {
              activeMiniCode.textContent = code;
            } else {
              activeMini.textContent = code;
            }

            activeMini.style.display = 'inline-flex';
          }

          if (activeBox) activeBox.style.display = 'flex';
          if (activeCode) activeCode.textContent = code;
          if (activeSavings) activeSavings.textContent = '';
          if (input) input.value = '';
        } else {
          if (label) label.textContent = 'Rabattcode';

          if (activeMini) {
            activeMini.style.display = 'none';
          }

          if (activeMiniCode) activeMiniCode.textContent = '';
          if (activeBox) activeBox.style.display = 'none';
          if (activeCode) activeCode.textContent = '';
          if (activeSavings) activeSavings.textContent = '';
          if (input) input.value = '';
        }
      });
    }

    function getDiscountEventSignature(cart) {
      if (!cart) return 'empty';

      var code = getVisibleCartDiscountCodes(cart).join(',');
      var itemCount = Number(cart.item_count || 0);
      var totalPrice = Number(cart.total_price || 0);
      var totalDiscount = Number(cart.total_discount || 0);

      return code + '|' + itemCount + '|' + totalPrice + '|' + totalDiscount;
    }

     function dispatchDiscountEvents(cart, force) {
      var signature = getDiscountEventSignature(cart);

      if (!force && signature === lastDiscountEventSignature) {
        scheduleCrossSellDiscountPrices(cart, 0);
        return;
      }

      lastDiscountEventSignature = signature;

      document.dispatchEvent(new CustomEvent('discount:updated', {
        detail: {
          cart: cart
        }
      }));

      document.dispatchEvent(new CustomEvent('quick-cart:discount-updated', {
        detail: {
          cart: cart
        }
      }));

      scheduleCrossSellDiscountPrices(cart, 0);
    }

       function syncAllLight(cart) {
      if (!cart) return;

      preserveConfiguredFrontendDiscountCode(cart);
      syncDiscountBoxes(cart);
      syncTotals(cart);
      syncFreeShippingBar(cart);
      applyLineItemCartJsonFallback(cart);
      dispatchDiscountEvents(cart);
      scheduleCrossSellDiscountPrices(cart, 0);
    }

        function syncAllAfterCoupon(cart, explicitCode, forceNormal) {
      if (!cart) return Promise.resolve();

      lastCartJson = cart;

      preserveConfiguredFrontendDiscountCode(cart);
      syncDiscountBoxes(cart);
      syncTotals(cart);
      syncFreeShippingBar(cart);
      dispatchDiscountEvents(cart, true);
      scheduleCrossSellDiscountPrices(cart, 0);

      return refreshLineItemsFromRenderedCart(cart, explicitCode, forceNormal)
        .then(function(result) {
          scheduleCrossSellDiscountPrices(cart, 150);
          return result;
        });
    }

    function scheduleCartSync(options) {
      options = options || {};

      var delay = typeof options.delay === 'number' ? options.delay : 700;
      var force = !!options.force;

      clearTimeout(syncTimer);

      syncTimer = setTimeout(function() {
        var now = Date.now();

        if (!force && lastCartJson && now - lastCartSyncAt < 1500) {
          syncAllLight(lastCartJson);
          return;
        }

        lastCartSyncAt = now;

        fetchCart()
          .then(function(cart) {
            syncAllLight(cart);
          })
          .catch(function(e) {
            console.warn('Quick cart discount sync failed:', e);
          });
      }, delay);
    }

    function applyDiscount(box) {
      if (!box) return;

      var actionToken = nextDiscountActionToken();
      var previousDiscountCodes = [];
      var previousCart = null;

      var input = box.querySelector('[data-qc-discount-input]');
      var code = input ? input.value.trim().toUpperCase() : '';

      hideMessage(box);

      if (!code) {
        showMessage(box, 'Bitte Code eingeben', 'error');
        if (input) input.focus();
        openDiscountBox(box);
        return;
      }

      rememberQuickCartEnteredCode(code);
      clearQuickCartCodeFromFrontendTracker(code);

      setLoading(box, true);
      openDiscountBox(box);
      showMessage(box, 'Rabattcode wird geprüft...', 'success');

      userClearedDiscount = false;
      clearDiscountTrackerProductCache();

      forceFreshCart()
        .then(function(cart) {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

          previousCart = cart;
          previousDiscountCodes = getApplicableCartDiscountCodes(cart);

          Object.keys(verifiedConfiguredCodes).forEach(function(configuredCode) {
            addUniqueDiscountCode(previousDiscountCodes, configuredCode);
          });

          var previousActiveDiscount = getActiveDiscount(cart);

          if (previousActiveDiscount && previousActiveDiscount.code) {
            addUniqueDiscountCode(previousDiscountCodes, previousActiveDiscount.code);
          }

          return updateCartDiscount(mergeDiscountCodes(previousDiscountCodes, code).join(','));
        })
        .then(function() {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();
          return forceFreshCart();
        })
        .then(function(cart) {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

          var applied =
            cartHasApplicableDiscountCode(cart, code) &&
            cartHasAllApplicableDiscountCodes(cart, previousDiscountCodes);

          if (applied) {
            return cart;
          }

          if (previousDiscountCodes.length) {
            return updateCartDiscount(
              mergeDiscountCodes(previousDiscountCodes, code).join(',')
            )
              .then(function() {
                return wait(350);
              })
              .then(function() {
                if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();
                return forceFreshCart();
              })
              .then(function(retryCart) {
                if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

                if (
                  cartHasApplicableDiscountCode(retryCart, code) &&
                  cartHasAllApplicableDiscountCodes(retryCart, previousDiscountCodes)
                ) {
                  return retryCart;
                }

                return updateCartDiscount(
                  mergeDiscountCodes(previousDiscountCodes, code).join(',')
                )
                  .then(function() {
                    return wait(450);
                  })
                  .then(function() {
                    if (!isCurrentDiscountAction(actionToken)) {
                      return stopOutdatedDiscountAction();
                    }

                    return forceFreshCart();
                  });
              });
          }

          return touchDiscountRoute(code)
            .then(function() {
              return wait(250);
            })
            .then(function() {
              if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();
              return forceFreshCart();
            });
        })
        .then(function(cart) {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

          lastCartJson = cart;

          var applied =
            cartHasApplicableDiscountCode(cart, code) &&
            cartHasAllApplicableDiscountCodes(cart, previousDiscountCodes);

          if (!applied) {
            return restoreApplicableDiscountCodes(previousDiscountCodes, cart)
              .then(function(restoredCart) {
                if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

                lastCartJson = restoredCart;

                var restoredDiscount = getActiveDiscount(restoredCart);

                if (restoredDiscount && restoredDiscount.code) {
                  userClearedDiscount = false;
                  setDiscountBoxesOptimistic(
                    getQuickCartDiscountCodeLabel(restoredCart, restoredDiscount.code)
                  );
                } else {
                  userClearedDiscount = true;
                  setDiscountBoxesOptimistic(null);
                }

                return syncAllAfterCoupon(
                  restoredCart,
                  restoredDiscount && restoredDiscount.code,
                  !restoredDiscount
                );
              })
              .then(function() {
                showMessage(box, 'Code ungültig oder nicht anwendbar', 'error');
                openDiscountBox(box);

                if (input) {
                  input.value = code;
                  input.focus();
                }
              });
          }

          userClearedDiscount = false;
          verifiedManualCodes[code] = true;

          var active = getActiveDiscount(cart);
          var activeCode = getPreferredQuickCartDiscountCode(cart, code) || code;
          var quickCartCodeLabel = getQuickCartDiscountCodeLabel(cart, activeCode);

          preserveConfiguredFrontendDiscountCode(cart);
          setDiscountBoxesOptimistic(quickCartCodeLabel);

          syncDiscountBoxes(cart);
          syncTotals(cart);
          syncFreeShippingBar(cart);
          dispatchDiscountEvents(cart, true);

          showMessage(box, 'Rabattcode wurde angewendet.', 'success');

          return forceLineItemsForCodeWithLightRetry(activeCode, cart, actionToken)
            .then(function() {
              if (!isCurrentDiscountAction(actionToken)) return;

              setTimeout(function() {
                if (isCurrentDiscountAction(actionToken)) {
                  hideMessage(box);
                }
              }, 1200);
            });
        })
        .catch(function(e) {
          if (e && e.__neOutdatedDiscountAction) return;

          console.warn('Apply discount failed:', e);

          return restoreApplicableDiscountCodes(
            previousDiscountCodes,
            previousCart || lastCartJson
          ).then(function(restoredCart) {
            var restoredDiscount = getActiveDiscount(restoredCart);

            userClearedDiscount = false;

            if (restoredDiscount && restoredDiscount.code) {
              setDiscountBoxesOptimistic(
                getQuickCartDiscountCodeLabel(restoredCart, restoredDiscount.code)
              );
              return syncAllAfterCoupon(restoredCart, restoredDiscount.code, false)
                .then(function() {
                  showMessage(box, 'Der Rabattcode konnte nicht angewendet werden.', 'error');
                  openDiscountBox(box);

                  if (input) {
                    input.value = code;
                    input.focus();
                  }
                });
            } else if (restoredCart) {
              return syncAllAfterCoupon(restoredCart)
                .then(function() {
                  showMessage(box, 'Der Rabattcode konnte nicht angewendet werden.', 'error');
                  openDiscountBox(box);

                  if (input) {
                    input.value = code;
                    input.focus();
                  }
                });
            }

            showMessage(box, 'Der Rabattcode konnte nicht angewendet werden.', 'error');
            openDiscountBox(box);

            if (input) {
              input.value = code;
              input.focus();
            }
          });
        })
        .finally(function() {
          if (isCurrentDiscountAction(actionToken)) {
            setLoading(box, false);
          }
        });
    }

    function removeDiscount(box) {
      if (!box) return;

      var actionToken = nextDiscountActionToken();

      hideMessage(box);
      setLoading(box, true);
      openDiscountBox(box);

      showMessage(box, 'Rabattcode wird entfernt...', 'success');

      userClearedDiscount = true;
      verifiedManualCodes = {};
      verifiedConfiguredCodes = {};
      clearDiscountTrackerProductCache();
      setDiscountBoxesOptimistic(null);

      if (lastCartJson) {
        forceLineItemsNormal();
      }

      updateCartDiscount('')
        .catch(function() {
          return null;
        })
        .then(function() {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();
          return forceFreshCart();
        })
        .then(function(cart) {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

          var active = getActiveDiscount(cart);

          if (active && active.code) {
            return touchClearDiscountRoute()
              .then(function() {
                return wait(250);
              })
              .then(function() {
                if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();
                return forceFreshCart();
              });
          }

          return cart;
        })
        .then(function(cart) {
          if (!isCurrentDiscountAction(actionToken)) return stopOutdatedDiscountAction();

          var active = getActiveDiscount(cart);

          if (active && active.code) {
            userClearedDiscount = false;
            setDiscountBoxesOptimistic(
              getQuickCartDiscountCodeLabel(cart, active.code)
            );

            showMessage(box, 'Der Rabattcode konnte nicht entfernt werden.', 'error');
            openDiscountBox(box);

            return syncAllAfterCoupon(cart, active.code, false);
          }

          userClearedDiscount = true;
          setDiscountBoxesOptimistic(null);

          showMessage(box, 'Rabattcode wurde entfernt.', 'success');

          return syncAllAfterCoupon(cart, null, true)
            .then(function() {
              if (!isCurrentDiscountAction(actionToken)) return;

              setTimeout(function() {
                if (isCurrentDiscountAction(actionToken)) {
                  hideMessage(box);
                }
              }, 1200);
            });
        })
        .catch(function(e) {
          if (e && e.__neOutdatedDiscountAction) return;

          console.warn('Remove discount failed:', e);

          showMessage(box, 'Der Rabattcode konnte nicht entfernt werden.', 'error');
          openDiscountBox(box);

          if (lastCartJson) {
            syncAllAfterCoupon(lastCartJson);
          }
        })
        .finally(function() {
          if (isCurrentDiscountAction(actionToken)) {
            setLoading(box, false);
          }
        });
    }

    function continueToCheckout() {
      window.location.assign(buildUrl('/checkout'));
    }

    function stabilizeDiscountCodesForCheckout(button) {
      if (checkoutDiscountSyncStarted) return;

      checkoutDiscountSyncStarted = true;

      if (button) button.disabled = true;

      forceFreshCart()
        .then(function(cart) {
          var checkoutCodes = getApplicableCartDiscountCodes(cart);

          Object.keys(verifiedConfiguredCodes).forEach(function(code) {
            addUniqueDiscountCode(checkoutCodes, code);
          });

          Object.keys(verifiedManualCodes).forEach(function(code) {
            addUniqueDiscountCode(checkoutCodes, code);
          });

          if (checkoutCodes.length < 2) return cart;

          return updateCartDiscount(checkoutCodes.join(','))
            .then(function() {
              return wait(250);
            })
            .then(forceFreshCart)
            .then(function(confirmedCart) {
              if (cartHasAllApplicableDiscountCodes(confirmedCart, checkoutCodes)) {
                return confirmedCart;
              }

              return updateCartDiscount(checkoutCodes.join(','))
                .then(function() {
                  return wait(350);
                })
                .then(forceFreshCart);
            });
        })
        .catch(function(error) {
          console.warn('Checkout discount sync failed:', error);
        })
        .then(continueToCheckout);
    }

    function handleClick(event) {
      var checkoutButton = event.target.closest('.quick-cart__submit[name="checkout"]');
      var toggle = event.target.closest('[data-qc-discount-toggle]');
      var applyBtn = event.target.closest('[data-qc-discount-apply]');
      var removeBtn = event.target.closest('[data-qc-discount-remove]');

      if (checkoutButton) {
        event.preventDefault();
        event.stopPropagation();

        stabilizeDiscountCodesForCheckout(checkoutButton);
        return;
      }

      if (toggle) {
        var toggleBox = getDiscountBox(toggle);
        if (!toggleBox) return;

        event.preventDefault();
        event.stopPropagation();

        var content = toggleBox.querySelector('[data-qc-discount-content]');
        var isOpen = toggleBox.classList.contains('is-open');

        toggleBox.classList.toggle('is-open', !isOpen);

        if (content) {
          content.style.display = !isOpen ? 'block' : 'none';
        }

        return;
      }

      if (applyBtn) {
        var applyBox = getDiscountBox(applyBtn);
        if (!applyBox) return;

        event.preventDefault();
        event.stopPropagation();

        applyDiscount(applyBox);
        return;
      }

      if (removeBtn) {
        var removeBox = getDiscountBox(removeBtn);
        if (!removeBox) return;

        event.preventDefault();
        event.stopPropagation();

        removeDiscount(removeBox);
      }
    }

    function handleKeydown(event) {
      if (event.key !== 'Enter') return;

      var input = event.target.closest('[data-qc-discount-input]');
      if (!input) return;

      var box = getDiscountBox(input);
      if (!box) return;

      event.preventDefault();
      event.stopPropagation();

      applyDiscount(box);
    }

    function stopDiscountInputPropagation(event) {
      if (
        event.target.closest('[data-qc-discount-input]') ||
        event.target.closest('[data-qc-discount-apply]') ||
        event.target.closest('[data-qc-discount-remove]')
      ) {
        event.stopPropagation();
      }
    }

    var neCrossSellPriceTimer = null;

    function scheduleCrossSellDiscountPrices(cart, delay) {
      clearTimeout(neCrossSellPriceTimer);

      neCrossSellPriceTimer = setTimeout(function() {
        document.dispatchEvent(new CustomEvent('ne:cross-sells:update'));
      }, typeof delay === 'number' ? delay : 0);
    }

    function forceCrossSellDiscountPricesAfterFirstOpen() {
      scheduleCrossSellDiscountPrices(lastCartJson, 0);
    }

    var neCartOpenTimer = null;
  var neCartAddTimer = null;
  var neCartFinalTimer = null;

  function softSyncAfterCartIsVisible() {
  clearTimeout(neCartOpenTimer);

  neCartOpenTimer = setTimeout(function() {
    scheduleCartSync({
      delay: 0,
      force: false
    });

    forceCrossSellDiscountPricesAfterFirstOpen();
  }, 220);
  }

  function softSyncAfterProductAdd() {
  clearTimeout(neCartAddTimer);
  clearTimeout(neCartFinalTimer);

  neCartAddTimer = setTimeout(function() {
    scheduleCartSync({
      delay: 0,
      force: true
    });

    forceCrossSellDiscountPricesAfterFirstOpen();
  }, 180);

  neCartFinalTimer = setTimeout(function() {
    scheduleCartSync({
      delay: 0,
      force: true
    });

    forceCrossSellDiscountPricesAfterFirstOpen();
  }, 700);
  }

    var initialUrlCode = getStoredFrontendDiscountCode();

    if (initialUrlCode) {
      saveFrontendCodeOnly(initialUrlCode, null, true);
    }

    document.addEventListener('click', handleClick, true);
    document.addEventListener('keydown', handleKeydown, true);

    document.addEventListener('mousedown', stopDiscountInputPropagation, false);
    document.addEventListener('touchstart', stopDiscountInputPropagation, false);
    document.addEventListener('input', stopDiscountInputPropagation, false);
    document.addEventListener('focus', stopDiscountInputPropagation, false);

    document.addEventListener('quick-cart:open', softSyncAfterCartIsVisible);
    document.addEventListener('cart:opened', softSyncAfterCartIsVisible);
    document.addEventListener('quick-cart:opened', softSyncAfterCartIsVisible);
    document.addEventListener('cart:refresh', softSyncAfterCartIsVisible);

    document.addEventListener('ajaxProduct:added', softSyncAfterProductAdd);
    document.addEventListener('product:added', softSyncAfterProductAdd);
    document.addEventListener('theme:cart:change', softSyncAfterProductAdd);

    document.addEventListener('cart:change', softSyncAfterProductAdd);
  document.addEventListener('cart:updated', softSyncAfterProductAdd);
  document.addEventListener('quick-cart:updated', softSyncAfterProductAdd);
    document.addEventListener('cart:items-updated', softSyncAfterProductAdd);

    window.addEventListener('ne:discount-applied-to-cart', function(event) {
      var detail = event && event.detail ? event.detail : {};
      var code = String(detail.code || '').trim().toUpperCase();

      if (
        code &&
        getConfiguredFrontendDiscountCodes().indexOf(code) !== -1 &&
        (!detail.cart || cartHasApplicableDiscountCode(detail.cart, code))
      ) {
        verifiedConfiguredCodes[code] = true;
      }
    });

    document.addEventListener('shopify:section:load', function() {
  setTimeout(function() {
    scheduleCartSync({
      delay: 0,
      force: true
    });

    forceCrossSellDiscountPricesAfterFirstOpen();
  }, 700);
  });

    /*
      Important:
      No MutationObserver here.
      The previous observer watched the whole body and could make quick add/cart open slow.
    */
  }

  function safeInitQuickCartDiscount() {
    if (window.__NEQuickCartDiscountInitStartedV15) return;
    window.__NEQuickCartDiscountInitStartedV15 = true;

    initQuickCartDiscount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(safeInitQuickCartDiscount, 300);
    });
  } else {
    setTimeout(safeInitQuickCartDiscount, 300);
  }
  })();
